module.exports = __webpack_public_path__ + "f92dcfc32979bcabab26178b230cac23.svg";